import bookImg from "../../assets/bookImg.jpg";
import dannyImg from "../../assets/danny.png";
import { PressSection } from "../PressSection/PressSection";
import { Reviews } from '../Reviews/Reviews';

export const Content = () => {
  return (
    <div className="mt-12">
      <div className="flex justify-center items-center relative">
        <img
          src={bookImg}
          alt="תמונה של הספר"
          className="shadow-2xl h-[22rem]"
          style={{ transition: "opacity 0.3s ease" }}
        />
      </div>

      {/* Book Information */}
      <div className="mt-12 text-center flex flex-col">
        {/* Title */}
        <div className="text-center font-semibold text-[1.7rem] ">
          מי לא מפחד כמוני מהאזעקה?
        </div>

        {/* Author */}
        <div className="text-sBlack opacity-50 ">לירז יוסף</div>

        {/* Book Description */}
        <div className="px-8 sBlack opacity-50 text-right mt-4 font-normal lg:px-24">
          ספר זה נכתב לאחר פרוץ מלחמת חרבות ברזל.
          <br /> הספר מסביר את הסיבות לפרוץ המלחמה ומציג שיטות ייחודיות שיסייעו
          לילדיכם להתמודד עם הלחץ בעת האזעקה.
          <br />
          זהו ספר ייחודי בכך שמשולבים בו
          <span className="text-cHightlight font-bold mr-1">
            סרטוני הסברה המיועדים לילדים ומתאימים למסופר בסיפור
          </span>

          . בסרטונים ניתן לצפות באמצעות הטלפון הסלולרי על ידי סריקת ברקוד QR.
          <br />
          כולי תקווה שהסיפור יסייע לילדים להתמודד עם פחדיהם, במיוחד מהאזעקות,
          יגביר את ביטחונם העצמי, יפיג את חששותיהם ויביא אותם ל
          <span className="text-cHightlight font-bold">רגיעה ולשלווה.</span>
          <br /><br/>שלום
          שמי לירז, אני אמא גאה לשני ילדים מדהימים בן 23 ובת 20. אני עובדת בתחום
          ההוראה כ-14 שנה. יש לי שני תארים בתחום החינוך ושתי התמחויות, התמחות
          בחינוך מיוחד והתמחות בספרות. בתואר השני למדתי ניהול וארגון מערכות
          חינוך. <br />
          כאשת חינוך נחשפתי לפחדיהם ולחששותיהם של התלמידים כאשר נשמעה אזעקה בזמן
          שלמדנו בזום ובזמן למידה בכיתה, ולכן החלטתי להוציא ספר כדי שיוכל לסייע
          לילדים להתגבר על הפחד כשנשמעת אזעקה. <br />
          הספר היה חבוי אצלי במגירה משנת 2017 ולאחר פרוץ מלחמת ״חרבות ברזל״
          החלטתי שזהו הזמן המדויק להוציא את הספר לאור. ההחלטה להוציא את הספר
          הייתה גם בעקבות המקרה המצער של מלאכית קטנה בשם תמר בת ה-9 ועשרה חודשים
          שהתמוטטה בביתה באשדוד בזמן שנשמעה אזעקה במלחמת ״חרבות ברזל", ונפטרה
          לאחר שבוע בבית החולים. ספר זה כולו מוקדש לזכרה והנצחתה של תמר טורפיאשוילי. חשבתי שאילו תמר הייתה קוראת את הספר שלי אולי היא
          הייתה פחות מפחדת ואולי הייתי יכולה להציל אותה, אבל עכשיו היא שם למעלה
          והיא זאת שתציל מיליוני ילדים בזכות הספר הזה. 
          <br/>
          בסוף הספר תוכלו למצוא את דבריו של כבוד הרב יאשיהו יוסף פינטו על חשיבות
        קריאת ספר דברים בשבת כפתרון יהודי וייחודי שיכול לסייע לחיזוק הנפש,
        לשלווה ולרוגע.
        </div>
        <br />
      </div>
      <div className="flex justify-center mt-6">
        <img src={dannyImg} className="h-32" alt="pointing-danny" />
      </div>
      <div className="text-center font-bold text-2xl">תקציר</div>
      <div className="px-8 sBlack opacity-50 text-right mt-2 font-normal lg:px-24 pb-12">
        ספר ילדים זה מסופר מנקודת מבטו של הילד דני, אשר משתף את הילדים איך בגיל
        שש, כאשר שמע את קול האזעקה, הוא החל לפחד מאוד. אביו ניסה להסביר לו מה
        עליו לעשות במקרה של אזעקה, ואכן הוא הבין, אך עדיין פחד. הוא המשיך וסיפר
        לו שיש אזעקות מפני שאין שלום בין היהודים לבין הפלסטינים והחזבאללה, ולכן
        אנחנו בריב איתם והם יורים עלינו טילים. אביו גילה לו שיש מכונה שהיא המצאה
        ישראלית שנקראת "כיפת ברזל", והיא מצליחה להשמיד את הטילים באוויר. אימו גם
        הסבירה לו על האנשים שהמציאו ופיתחו את מערכת כיפת ברזל והיא כל הזמן
        הזכירה לו ש
        <span className="text-cHightlight font-bold">
          האזעקה עוזרת לנו ושומרת עלינו
        </span>
        , ואמרה לו שחשוב שיזכור: "האזעקה היא סימן לגשת למרחב המוגן" ודני הבין
        ואמר:
        <span className="text-cHightlight font-bold mr-1">
          "כששומעים שוב ושוב את האזעקה היא פחות מפחידה".
        </span>
        <br />
        ההסברים הללו העניקו לדני הבנה טובה יותר של המציאות שבה כולנו חיים, וכך
        הוא
        <span className="text-cHightlight font-bold mr-1">נרגע</span>. מה שעזר
        לדני להירגע ולהיות שלו יותר, הוא לשיר שירים כשנשמעה אזעקה והוא שהה במרחב
        המוגן.
        <br/>
                 כמו כן, הספר מעניק לילדים הסבר כללי על המציאות בארץ. כאשר ספר מסופר
          מנקודת מבטו של ילד, קל יותר לילדים להזדהות איתו ולהפנים את המסר:
          <span className="text-cHightlight font-bold mr-1">
            "האזעקה עוזרת לנו ומגינה עלינו, ואין לפחד ממנה"
          </span>.
      </div>
      <PressSection />
      <Reviews />
    </div>
  );
};
